import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslateService } from '@services/translate.service';
import { StandingsDialogComponent } from './standings.dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@environments/environment';
import { addDays } from 'date-fns';
import { liveStreamData, LiveStreamService } from '@services/liveStream.service';
import { pushToDataLayer } from '@helpers/gtm.util';
import { BonusSummaryModal } from './bonus-summary-modal';

@Component({
  selector: 'match-r',
  templateUrl: '../sharedTemplates/match.row.component.html',
})
export class MatchRowComponent implements OnInit, OnChanges {
  @Input() set oddType(e) {
    // .log(e);
    if (typeof e === 'object') {
      this.oddTypeArray = e;
    } else if (typeof e === 'string' || typeof e === 'number') {
      this.oddTypeArray.push(e);
    }
    this.init();
  }

  // todo connect env

  constructor(
    public _DataHelper: DataHelper,
    private _router: Router,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiHelper: ApiService,
    public dialog: MatDialog,
    public _LiveStreamService: LiveStreamService
  ) {}

  @Output() eventDetailEventId = new EventEmitter();

  @Input() _d = <any>{};
  @Input() _isLive = false;
  @Input() _isWide = false;
  @Input() _selectedOdds = [];
  oddTypeArray = [];

  @Input() _sportName;
  @Input() _activeOddType;
  @Output() favChanged = new EventEmitter();

  oddDatas = {};
  mLine = [false];
  @Output() addOdd = new EventEmitter();
  _oddTypes = this._DataHelper.oddTypes;

  isSmallDesktop = false;

  @Input() _LineIndex = 0;

  today = new Date();
  sevenDayAfter = addDays(this.today, 7);

  betId = 0;
  iconUrl: string;
  liveStream: liveStreamData;

  favorableStateChanged(e, _id) {
    this._UserHelper.toogleFavoried(_id);
    this.favChanged.emit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes._sportName) {
      this.init();
    }
  }

  ngOnInit(): void {
    this._UiHelper.windowsWidth < 1250 ? (this.isSmallDesktop = true) : (this.isSmallDesktop = false);
    this._UiHelper.windowResized.subscribe(x => {
      this._UiHelper.windowsWidth < 1250 ? (this.isSmallDesktop = true) : (this.isSmallDesktop = false);
    });
    this.updateIconUrl();
  }

  init() {
    try {
      const localSportName = String(this._sportName + '');
      if (!localSportName) {
        return;
      }
      this.oddTypeArray.forEach(_y => {
        let oddType = _y;
        if (this._isLive === false && _y === 22) {
          // For Upcoming
          oddType = 1;
        }

        if (this._isLive === false && _y === 12) {
          // For Upcoming  first team to score => upcoming NG
          oddType = 27;
        }

        if (this._isLive === false && _y === 10) {
          // For Upcoming
          oddType = 2;
        }
        // Basketball upcoming
        if (this._isLive === false && _y === 10 && localSportName === 'Basketball') {
          oddType = 25;
        }

        if (this._DataHelper.oddTypes[oddType] && this._DataHelper.oddTypes[oddType][localSportName]) {
          // console.log('SPORT SPECIFIC', localSportName, oddType);

          this.oddDatas = {
            ...this.oddDatas,
            [_y]: this._oddTypes[oddType][localSportName],
          };
        } else {
          // console.log('SPORT ALL', localSportName, oddType);

          this.oddDatas = {
            ...this.oddDatas,
            [_y]: this._oddTypes[oddType]['all'],
          };
        }
        if (Array.isArray(this.oddDatas[_y]) && this.oddDatas[_y].length > 0 && this.oddDatas[_y][0].set && this.oddDatas[_y][0].set.mLine !== null) {
          if (this.oddDatas[_y][0].set.mLine === true) {
            this.mLine[_y] = true;
            this.oddDatas = {
              ...this.oddDatas,
              [_y]: this.reBuilderData(this.oddDatas[_y]),
            };
          } else {
            this.mLine[_y] = false;
          }
        } else {
          this.mLine[_y] = false;
        }
      });
    } catch (e) {
      console.log(e);
    }
  }
  isMatchIdInCurrentSlipData(matchId: number): boolean {
    if (!Array.isArray(this._DataHelper.currentSlipData)) {
      // currentSlipData bir dizi değilse, false döner
      return false;
    }
    return this._DataHelper.currentSlipData.some(slip => slip.MatchId === matchId);
  }
  reBuilderData(oddConfig) {
    const perLine = oddConfig[0].set.perLine;
    const rebuildedOdds = [];
    oddConfig.map((oddConfigItem, index) => {
      const arrayIndex = Math.floor(index / perLine);
      if (!rebuildedOdds[arrayIndex]) {
        rebuildedOdds[arrayIndex] = [];
      }
      rebuildedOdds[arrayIndex].push(oddConfigItem);
    });
    return rebuildedOdds;
  }

  clickOddUP(_oddId, isActive?) {
    if (!this._DataHelper.ChangeOddIsActive && environment.submitBetModifyControl) {
      return '';
    }

    const newodd = {
      OddId: _oddId,
    };

    const index = this._ApiHelper.slipCurrents.findIndex(v => {
      return v.OddId1 == _oddId;
    });

    if (isActive != null) {
      if (isActive) {
        this.addOdd.emit(_oddId);
      }
    } else {
      this.addOdd.emit(_oddId);
    }
  }

  clickNewOdd(e, a) {
    const _outcome = a.preTextT ? this._TranslateService.instant(a.preTextT, null) : a.preText;
    const _market = this._TranslateService.instant(a.Gname, null);
    this._DataHelper.currentSlipVorabTicket = [];
    const isactive = e['OddValue' + a.type] != null && e['OddValue' + a.type + 'Visibility'] != 'hidden';

    this._DataHelper.freebetBonusCheckBox = false;
    this._DataHelper.boostBonusCheckBox = false;

    let _betType = this._isLive ? 1 : 0;
    if (this._isLive && e.EventStatu != null) {
      _betType = 0;
    }
    this._DataHelper.setBetAmounts();
    //Kullanıcının Bonus hakkı olup olmadığını kontrol ediyoruz.
    if (this._DataHelper.selectedWallet.IsFreeBetBonus || this._DataHelper.selectedWallet.IsBoostBonus) {
      this.openBonusModal();
    }
    // 07-03-2022 - SpecialBetValue Parantez kaldırıldı. Sebebi : İlk data da Parantezli geliyordu. Sonra refresh olunca gidiyordu parantez !
    // 07-03-2022 - Soccer için specialIsActive eklendi. Böylece Data ilk geldiğinde SpecialBetValue olmadığında Score gösterilmiş oldu !
    const newOdd = {
      Banko: false,
      BetType: _betType,
      Enable: true,
      EventDateLong: this._isLive ? (e.EventDate ? e.EventDate : e.MatchDate) : e.MatchDate,
      EventName: this._isLive ? e.HomeTeam + ' - ' + e.AwayTeam : e.EventName,
      MatchId: this._isLive ? e.EventId : e.MatchId,
      OddId1: e['OddId' + a.type],
      OddsType: _market,
      OddsTypeId: 1839,
      OddValue1: e['OddValue' + a.type],
      OutCome: _outcome,
      ShortOddType: _market,
      // "SpecialBetValue": e['OddSpecialBetValue' + a.lineText] != undefined ? e['OddSpecialBetValue' + a.lineText] : '',
      SpecialBetValue: a.specialIsActive == false ? e['Score'] : e['OddSpecialBetValue' + a.lineText] != undefined ? e['OddSpecialBetValue' + a.lineText] : e['' + a.lineText],
      Visibility: '',
      HomeTeam: e.HomeTeam,
      AwayTeam: e.AwayTeam,
    };

    this._ApiHelper.addOddDirectly(newOdd);
  }

  openDialogStandings(e): void {
    let matchId;
    if (e.MapMatchId && e.MapMatchId !== '0') {
      matchId = e.MapMatchId;
    } else {
      matchId = e.BetradarMatchId;
    }
    const dialogRef = this.dialog.open(StandingsDialogComponent, {
      id: 'standingsDialog',
      panelClass: 'standingsDialogClass',
      height: '90%',
      width: '90%',
      data: {
        tournamentId: e.BetradarTournamentId,
        sportId: e.SportId,
        betradarMatchId: matchId,
        type: 'headToHead',
      },
    });
    pushToDataLayer({ event: 'fixture_list_signal_click' });
  }

  checkOddId(oddId) {
    const index = this._ApiHelper.slipCurrents.findIndex(v => {
      return v.OddId1 == oddId;
    });
    if (index > -1) {
      return 'active';
    } else {
      return '';
    }
  }

  goEventDetail(e, f) {
    if (e && !f) {
      this._router.navigate(['/eventdetail', e]);
    } else if (!e && f) {
      this._router.navigate(['/liveeventdetail', f]);
    }
  }

  goEventDetail2(e, f, g) {
    this._DataHelper.selectedMatch = g;

    const ismobile = this._UiHelper.windowsWidth < 990 ? true : false;
    if (g == null) {
      if (ismobile) {
        const matchId = e == null ? f : e;
        this._UiHelper.setMatchDetailData(matchId, false);
      } else {
        this._router.navigate(['/eventdetail', e == null ? f : e]);
      }
    } else if (g.HasStreaming == null || g.HasStreaming == 'pre' || g.HasStreaming == false) {
      if (ismobile) {
        const matchId = e == null ? f : e;
        this._UiHelper.setMatchDetailData(matchId, false);
      } else {
        this._router.navigate(['/eventdetail', e == null ? f : e]);
      }
    } else {
      if (ismobile) {
        const matchId = e == null ? f : e;
        this._UiHelper.setMatchDetailData(matchId, true);
      } else {
        this._router.navigate(['/liveeventdetail', e == null ? f : e]);
      }
    }
    this._UiHelper.p1001SetMatchDetailDialog('open');
  }

  addMatch2Favs(item: any): void {
    if (this._UserHelper.isSignedIn) {
      this._DataHelper.setFavList(item.BetradarMatchId);
    }
  }

  OpenDetails(id: number) {
    this.eventDetailEventId.emit(id);
    if (id == this.betId) {
      this.betId = 0;
    } else {
      this.betId = id;
    }
  }

  getWhich(matchDate: Date): number {
    const _today = new Date(this.today).getDate();
    const _matchDate = new Date(matchDate).getDate();

    const _month = new Date(this.today).getMonth();
    const _monthDate = new Date(matchDate).getMonth();

    if (_today === _matchDate && _month == _monthDate) {
      return 1;
    }

    if (this.sevenDayAfter > new Date(matchDate)) {
      return 2;
    }

    return 3;
  }

  getResponsiveOddShow(indexOddOrder) {
    switch (indexOddOrder) {
      case 1:
        return this._UiHelper.isResponsiveRules(['s']);
      case 2:
        return this._UiHelper.isResponsiveRules(['xl']);
      case 3:
        return this._UiHelper.isResponsiveRules(['xxl']);
      default:
        return true;
    }
  }

  updateIconUrl() {
    const currentWeekNumber = Math.ceil(new Date().getDate() / 7);
    this.iconUrl = currentWeekNumber % 2 === 0 ? 'star' : 'signal';
  }
  onIconClick(_d) {
    const iconType = this.iconUrl === 'star' ? 'star' : 'signal';
    if (iconType === 'star') {
      this.addMatch2Favs(_d);
      pushToDataLayer({ event: 'fixture_list_star_click' });
    } else if (iconType === 'signal') {
      this.openDialogStandings(_d);
    }
  }
  splitAndCheckScore(score: string | null | undefined): (string | null)[] {
    if (typeof score !== 'string' || score === null || score === undefined) {
      return [null, null];
    }
    return score.split(':').map(part => (part !== '-' ? part : null));
  }
  openBonusModal() {
    //Sadece bir kere çalışması için flag yapısı kuruldu.
    if (!this._UiHelper.bonusModalflag && (this._DataHelper.customerFreeBetBonusInfo || this._DataHelper.customerBoostBonusInfo)) {
      this.dialog.open(BonusSummaryModal, {
        width: '500px',
        panelClass: 'Bonus_Info_Modal',
      });
      this._UiHelper.bonusModalflag = true;
    }
  }
}

// Bakalım kim gerçekten review ediyor görelim :)
// Görelim :)
